import gql from 'graphql-tag';

const MODIFY_PLANOGRAM_ITEM_PARLEVEL = gql`
	mutation modifyPlanogramItem (
		$id: ID,
		$values: PlanogramItemInput,
	) {
		modifyPlanogramItem(
			id: $id,
			values: $values,
		) {
			id
			parlevel
			queuedParlevel
			queuedParlevelType
		}
	}
`;

export default MODIFY_PLANOGRAM_ITEM_PARLEVEL;

